import { render, staticRenderFns } from "./RHZ.vue?vue&type=template&id=b82a3854&scoped=true"
import script from "./RHZ.vue?vue&type=script&lang=js"
export * from "./RHZ.vue?vue&type=script&lang=js"
import style0 from "./RHZ.vue?vue&type=style&index=0&id=b82a3854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a3854",
  null
  
)

export default component.exports